import { useEffect } from "react"

export const useMountAPI = (shouldBeCalled, changeHandler = null) => {
    useEffect(() => {
        shouldBeCalled(changeHandler)
    }, [])
}

export const useUpdateAPI = (shouldBeCalled, changeHandler = null, sensitive=[]) => {
    useEffect(() => {
        shouldBeCalled(changeHandler)
    }, sensitive)
}


